import { useEffect, useState } from "react";
import { useEditorStore } from "@/store";
import { GLYPH_PRESETS } from "@/lib/presets";

/**
 * Returns a list of available font names based on the current glyphs URL.
 * Matches against known presets, and also extracts fonts used in existing layers.
 */
export function useAvailableFonts(): string[] {
  const glyphs = useEditorStore((s) => s.style.glyphs) as string | undefined;
  const layers = useEditorStore((s) => s.style.layers);
  const [fonts, setFonts] = useState<string[]>([]);

  useEffect(() => {
    const fontSet = new Set<string>();

    // Match current glyphs URL against known presets
    if (glyphs) {
      for (const preset of GLYPH_PRESETS) {
        if (glyphs === preset.url) {
          for (const f of preset.fonts) fontSet.add(f);
        }
      }
    }

    // Extract fonts already used in layers
    for (const layer of layers) {
      const textFont = layer.layout?.["text-font"];
      if (Array.isArray(textFont)) {
        for (const f of textFont) {
          if (typeof f === "string") fontSet.add(f);
        }
      }
    }

    // Common fallback fonts always available
    if (fontSet.size === 0) {
      fontSet.add("Open Sans Regular");
      fontSet.add("Open Sans Bold");
      fontSet.add("Open Sans Semibold");
      fontSet.add("Open Sans Italic");
      fontSet.add("Arial Unicode MS Regular");
      fontSet.add("Arial Unicode MS Bold");
    }

    setFonts([...fontSet].sort());
  }, [glyphs, layers]);

  return fonts;
}
